import { defaultSkyScrapper, IAdUnit } from "../unit";

export enum HomepageSkyscraperEnum {
  HomepageSkyscraperL1="Homepage Skyscraper L1",
  HomepageSkyscraperR1="Homepage Skyscraper R1",
  HomepageSkyscraperL2="Homepage Skyscraper L2",
  HomepageSkyscraperR2="Homepage Skyscraper R2",
  HomepageSkyscraperL3="Homepage Skyscraper L3",
  HomepageSkyscraperR3="Homepage Skyscraper R3",
}

type HomepageSkyscraperEnumT = typeof HomepageSkyscraperEnum;

export const homepageSkyscraperUnits: {[name in HomepageSkyscraperEnumT[keyof HomepageSkyscraperEnumT]]: IAdUnit} = {
  [HomepageSkyscraperEnum.HomepageSkyscraperL1]: {
    ...defaultSkyScrapper,
    sid: "1232677",
  },
  [HomepageSkyscraperEnum.HomepageSkyscraperR1]: {
    ...defaultSkyScrapper,
    sid: "1232678",
  },
  [HomepageSkyscraperEnum.HomepageSkyscraperL2]: {
    ...defaultSkyScrapper,
    sid: "1232679",
  },
  [HomepageSkyscraperEnum.HomepageSkyscraperR2]: {
    ...defaultSkyScrapper,
    sid: "1232680",
  },
  [HomepageSkyscraperEnum.HomepageSkyscraperL3]: {
    ...defaultSkyScrapper,
    sid: "1232681",
  },
  [HomepageSkyscraperEnum.HomepageSkyscraperR3]: {
    ...defaultSkyScrapper,
    sid: "1232682",
  },
};
